<template>
	<div class="main">
		<hwk-header></hwk-header>
		<div class="warp flex o-d-main">
			<div class="o-d-l">
				<div class="back pointer" @click="goBack">
					<i class="el-icon-arrow-left"></i><span>订单详情</span>
				</div>
				<div class="state" v-if="status == 10">待支付</div>
				<div class="state" v-if="status == 15">待审核</div>
				<div class="state" v-if="status == 20">待发货</div>
				<div class="state" v-if="status == 30">已发货</div>
				<div class="state" v-if="status == 40">已收货</div>
				<div class="state" v-if="status == 50">已完成</div>
				<div class="state" v-if="status == 60">交易关闭</div>
				<div class="o-hd" v-if="status > 20 && status < 60 && order_address.logistics_company">
					<img src="@/assets/kd.png" alt="" />
					<p>{{order_address.logistics_company}}_{{order_address.logistics_number}} <span class="pointer"
							@click="seeImg(http + order_address.logistics_images)">查看快递面单</span></p>
				</div>
				<div class="address" v-if="form && form.id">
					<div class="l">
						<i class="el-icon-location"></i>
					</div>
					<div class="r">
						<p><span>{{form.address_address_one}}</span><span>{{form.address_city}}</span><span>{{form.address_province}}</span><span>{{form.address_country}}</span>
						</p>
						<p><span>{{form.address_name}}</span><span>{{form.address_phone}}</span><span>{{form.address_email}}</span>
						</p>
					</div>
					<!-- 1 中 2成功 3 驳回 -->
					<div class="sh sh1" v-if="form.status == 1"><img src="@/assets/w.png" alt="" /><span>地址审核中</span>
					</div>
					<div class="sh sh1" v-if="form.status == 3"><img src="@/assets/stop.png"
							alt="" /><span>地址审核驳回</span>
					</div>
					<div class="sh sh2" v-if="form.status == 2"><img src="@/assets/ok.png" alt="" /><span>地址审核通过</span>
					</div>
					<div class="bh pointer" v-if="form.status == 3" @click="seeReject">查看驳回原因</div>
				</div>
				<div class="btns flex">
					<div class="btn btn1 pointer" v-if="status == 10" @click="payShow = true">立即支付</div>
					<div class="btn btn2 pointer" @click="pageToApply"
						v-if="status == 15||status == 20||status == 30||status == 50||status == 40">申请售后</div>
					<div class="btn btn2 pointer" v-if="status < 30 && (form.status == 0 || form.status == 3)"
						@click="changeAddr">修改地址</div>
					<div class="btn btn2 pointer" v-if="status == 30" @click="recycle">确认收货</div>
				</div>
				<div class="hr"></div>
				<div class="gl" v-if="order_refund.length > 0">
					<div class="i flex" v-for="(item,index) in order_refund" :key="index"
						@click="pageToRefOrder(item.id)">
						<div class="gl-l">
							关联售后单 | {{item.refund_order_number}}
						</div>
						<div class="gl-r flex">
							<span v-if="item.status == 1">待处理</span>
							<span v-if="item.status == 2">已处理</span>
							<span v-if="item.status == 3">已驳回</span>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>

				</div>
				<div class="hr"></div>
				<div class="o-d-title">出售信息</div>
				<div class="o-d-list flex">
					<div class="i">
						出售平台：<span>{{form.source_string}}</span>
					</div>
					<div class="i">
						出售店铺：<span>{{form.user_shop_string}}</span>
					</div>
					<div class="i">
						订单编号：<span>{{form.other_order_number}}</span>
					</div>
				</div>
				<div class="o-d-goods">
					<div class="item1">
						<div class="i i1">商品</div>
						<div class="i i2">
							价格
						</div>
					</div>
					<div class="item" v-for="(item,index) in order_goods" :key="index"
						@click="toDetails(item.goods_id)">
						<div class="img">
							<img :src="http + item.goods_image" alt="" />
						</div>
						<div class="con">
							<div class="name">{{item.goods_title}}</div>
							<div class="p">{{data.warehouse_string}}</div>
							<div class="p">{{item.goods_child_sku_string}}</div>

						</div>
						<div class="price">
							<p>￥{{item.price}}</p>
							<p>x{{item.number}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="o-d-r">
				<div class="title">付款详情</div>
				<div class="list">
					<div class="item">
						<div class="l">商品数量</div>
						<div class="r ">共<b class="num-din">{{total}}</b>件</div>
					</div>
					<div class="item">
						<div class="l">商品总价</div>
						<div class="r">￥<span style="font-weight: 600;" class="num-din">{{getTotalPs(data)}}</span>
						</div>
					</div>
					<div class="item"
						v-if="data && data.order_address && data.order_address.logistics_price && data.order_address.logistics_price != '0.00'">
						<div class="l">运费</div>
						<div class="r">￥<span style="font-weight: 600;"
								class="num-din">{{data.order_address.logistics_price}}</span>
						</div>
					</div>
					<div class="item">
						<div class="l">签名服务</div>
						<div class="r">￥<span style="font-weight: 600;" class="num-din">
								{{data.sign_price}} </span>
						</div>
					</div>
					<div class="item">
						<div class="l">实付款</div>
						<div class="r">￥<span v-if="data.is_new == 2">0</span><span v-if="data.is_new == 1"
								style="font-weight: 600;" class="num-din">{{data.pay_price}}</span></div>
					</div>
				</div>
				<div class="hr"></div>
				<div class="title">订单信息</div>
				<div class="list">
					<div class="item">
						<div class="l">系统订单</div>
						<div class="r flex">{{data.order_number}} <img src="@/assets/copy.png" alt=""
								@click="copyText(data.order_number)" /></div>
					</div>
					<div class="item">
						<div class="l">创建时间</div>
						<div class="r">
							{{$timeFormat(data.updatetime,'yyyy-mm-dd hh:MM')||$timeFormat(data.createtime,'yyyy-mm-dd hh:MM:ss')}}
						</div>
					</div>
					<div class="item" v-if="status > 15 && status < 60 && data.is_new == 1">
						<div class="l">付款时间</div>
						<div class="r">
							{{data.pay_time}}
						</div>
					</div>
					<div class="item" v-if="status > 10 && status < 60 && data.is_new == 1">
						<div class="l">支付方式</div>
						<div class="r" v-if="data.pay_type == 0">未知</div>
						<div class="r" v-if="data.pay_type == 1">授信结算</div>
						<div class="r" v-if="data.pay_type == 2">支付宝</div>
						<div class="r" v-if="data.pay_type == 3">微信</div>
						<div class="r" v-if="data.pay_type == 4">银联支付</div>
					</div>
					<div class="item" v-if="status  >= 30 && data.order_address.logistics_time">
						<div class="l">发货时间</div>
						<div class="r">
							{{data.order_address.logistics_time}}
						</div>
					</div>
					<div class="item" v-if="status  >= 50 && data.recycle_order_time">
						<div class="l">收货时间</div>
						<div class="r">
							{{data.recycle_order_time.slice(0,10)}}
						</div>
					</div>
					<div class="item" v-if="status  == 50 && data.is_new == 1">
						<div class="l">完成时间</div>
						<div class="r">
							{{data.success_order_time}}
						</div>
					</div>

					<!-- <div class="item" v-if="data.pay_type == 4">
						<div class="l">支付凭证</div>
						<div class="r">
							<el-image style="width: 30px; height: 30px" :src="payimg" :preview-src-list="[payimg]">
							</el-image>
						</div>
					</div> -->
				</div>
			</div>
		</div>
		<navigation :usershow='false'></navigation>



		<el-dialog title="修改收货地址" :visible.sync="dialogFormVisible" width="980px">
			<div class="textarea">
				<el-input type="textarea" :rows="3" placeholder="在这里粘贴或输入地址..." v-model="textarea">
				</el-input>
				<el-button type="primary" size="small" @click="analysis">识别地址</el-button>
			</div>
			<div class="tips flex">
				<i class="el-icon-warning-outline"></i>
				<span>自动输入是机器学习的结果，无法保证完全正确，请检查下方地址。</span>
			</div>

			<el-form :model="form" label-position="left" :rules="rules" ref="ruleForm">
				<table class="table-form">
					<tr>
						<td>
							<el-form-item label="姓名" :label-width="formLabelWidth" prop="address_name">
								<el-input v-model="form.address_name" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
						<td>
							<el-form-item label="电话" :label-width="formLabelWidth" prop="address_phone">
								<el-input v-model="form.address_phone" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址一" :label-width="formLabelWidth" prop="address_address_one">
								<el-input v-model="form.address_address_one" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址二" :label-width="formLabelWidth" prop="address_address_two">
								<el-input v-model="form.address_address_two" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址三" :label-width="formLabelWidth" prop="address_address_three">
								<el-input v-model="form.address_address_three" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td>
							<!-- <el-form-item label="门牌号" :label-width="formLabelWidth">
								<el-input v-model="form.address_house_number" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item> -->
							<el-form-item label="邮编" :label-width="formLabelWidth" prop="address_zip_code">
								<el-input v-model="form.address_zip_code" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td>
						<td>
							<el-form-item label="邮箱" :label-width="formLabelWidth">
								<el-input v-model="form.address_email" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td>
							<el-form-item label="省/州/府" :label-width="formLabelWidth" prop="address_province">
								<el-input v-model="form.address_province" autocomplete="off"
									placeholder="请输入"></el-input>
								<!-- <el-select v-model="form.address_province" placeholder="请选择" style="width: 100%;"
									@change="changeProvinces" :disabled="!form.address_country">
									<el-option :label="item.label" :value="item.value" v-for="(item,index) in provinces"
										:key="index"></el-option>
								</el-select> -->
							</el-form-item>
						</td>
						<td>
							<el-form-item label="城市/区" :label-width="formLabelWidth" prop="address_city"
								:disabled="!form.address_province">
								<el-input v-model="form.address_city" autocomplete="off" placeholder="请输入"></el-input>
								<!-- <el-select v-model="form.address_city" placeholder="请选择" style="width: 100%;">
									<el-option label="区域一" value="shanghai"></el-option>
									<el-option label="区域二" value="beijing"></el-option>
								</el-select> -->
							</el-form-item>
						</td>
					</tr>
					<tr>
						<!-- <td>
							<el-form-item label="邮编" :label-width="formLabelWidth" prop="address_zip_code">
								<el-input v-model="form.address_zip_code" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td> -->
						<td colspan="2">
							<el-form-item label="国家" :label-width="formLabelWidth" prop="address_country">
								<el-input v-model="form.address_country" autocomplete="off"
									placeholder="请输入"></el-input>
								<!-- <el-select v-model="form.address_country" placeholder="请选择" style="width: 100%;"
									@change="changeCountry">
									<el-option :label="item.label" :value="item.value" v-for="(item,index) in countrys"
										:key="index"></el-option>
								</el-select> -->
							</el-form-item>
						</td>
					</tr>
				</table>
				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="" label-width="0" prop="address_source_id">
							<el-select v-model="form.address_source_id" placeholder="选择订单来源" style="width: 100%;"
								@change="sourceChange">
								<el-option :label="item.name" :value="item.id" v-for="(item,index) in slist"
									:key="index"></el-option>

							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="" label-width="0" prop="address_user_shop_id">
							<el-select v-model="form.address_user_shop_id" placeholder="选择店铺" style="width: 100%;"
								:disabled="!form.address_source_id" @change="shopChange">
								<el-option :label="item.name" :value="item.id" v-for="(item,index) in shoplist"
									:key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="" label-width="0" prop="address_other_order_number">
							<el-input v-model="form.address_other_order_number" autocomplete="off"
								placeholder="请填写订单编号"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="addressOk('ruleForm')" size="small">保 存</el-button>
			</div>
		</el-dialog>

		<!-- 支付 -->
		<el-dialog title="订单支付" :visible.sync="payShow" width="700px">
			<div class="payprice">
				支付金额:<span>￥{{order_money}}</span>
			</div>
			<div class="paytype flex">
				<div class="l">支付方式</div>
				<div class="r flex">
					<!-- <div class="i flex" @click="changePayType(0)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==0" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay1.jpg" class="img2" />
					</div> -->
					<div class="i flex" @click="changePayType(1)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==1" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay2.jpg" class="img2" />
					</div>
					<div class="i flex" @click="changePayType(2)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==2" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay3.jpg" class="img2" />
					</div>
					<div class="i flex" @click="changePayType(3)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==3" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay4.jpg" class="img2" />
					</div>
				</div>
			</div>
			<div class="payma1" v-if="payType==-1">
				<img src="@/assets/nopay.png" />
				<p>选择支付方式</p>
			</div>
			<div class="payma2" v-if="payType==0">
				<!-- <img :src="alpay" v-if="alpay" /> -->
				<iframe :src="alpay" width="210px" height="210px" frameborder="0" v-if="alpay">
				</iframe>
				<p>请使用<span>支付宝</span>扫码 <br>完成支付</p>
			</div>
			<div class="payma2" v-if="payType==1">
				<img :src="wxpay" v-if="wxpay" />
				<p>请使用<span>微信</span>扫码 <br>完成支付</p>
			</div>
			<div class="payma3" v-if="payType==2">
				<!-- <div class="zh flex" v-for="(item,index) in order_bank_card" :key="index">
					<div class="l">账户信息</div>
					<div class="r flex">
						<div class="i">{{item.gs}}</div>
						<div class="i">{{item.yh}}</div>
						<div class="i">{{item.kh}}</div>
					</div>
				</div> -->
				<div class="zh flex" v-for="(item,index) in order_bank_card2" :key="index">
					<div class="l">账户信息</div>
					<div class="r flex">
						{{item}}
					</div>
				</div>

				<div class="pz">
					<div class="t">支付凭证<span>请打款至账户信息，并上传支付凭证</span></div>
					<el-upload class="avatar-uploader" :action="action" :headers="headers" :show-file-list="false"
						:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="imageUrl" :src="http + imageUrl" class="avatar">
						<div class="upload" v-else>
							<img src="@/assets/upimg.png" />
							<p>添加图片</p>
						</div>
					</el-upload>
				</div>
			</div>
			<div class="payma4" :class="{payma4on:canPay}" v-if="payType==3">
				<div class="t flex">
					<div class="l">可用额度</div>
					<div class="r">￥<span>{{user_money}}</span></div>
				</div>
				<div class="ma">
					<img src="@/assets/sx1.png" v-if="canPay" />
					<img src="@/assets/sx2.png" v-else />
					<p>{{canPay?'点击确认支付':'额度不足，请选择其他支付方式'}}</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="payShow = false" size="small">关闭</el-button>
				<el-button type="primary" @click="paySubmit" size="small">确认支付</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	// import json from '../api/json.js'
	import hwkHeader from './hwk-header.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation
		},
		data() {
			return {
				order_goods: [],

				imageUrl: '',
				headers: {
					token: localStorage.getItem('token')
				},
				action: this.$upload,
				http: this.$imgUrl,
				http2: this.$imgWebUrl,
				payType: -1,
				canPay: false,
				user_money: 0,
				payShow: false,
				order_money: 0,
				textarea: "",
				dialogFormVisible: false,
				id: '',
				data: {},

				form: {
					address_name: '',
					address_phone: '',
					address_address_one: '',
					address_address_two: '',
					address_address_three: '',
					// address_house_number: '',
					address_email: '',
					address_country: '',
					address_province: '',
					address_city: '',
					address_area: '',
					address_zip_code: '',
					address_source_id: '',
					address_source_string: '',
					address_user_shop_id: '',
					address_user_shop_string: '',
					address_other_order_number: '',
					source_id: '',
					source_string: '',
					user_shop_id: '',
					user_shop_string: '',
					other_order_number: '',
					reject_message: ""
				},
				formLabelWidth: '80px',
				countrys: [],
				provinces: [],
				citys: [],
				rules: {
					address_name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					address_phone: [{
						required: true,
						message: '请输入电话',
						trigger: 'blur'
					}],
					address_address_one: [{
						required: true,
						message: '请输入地址1',
						trigger: 'blur'
					}],

					// address_house_number: [{
					// 	required: true,
					// 	message: '请输入门牌号',
					// 	trigger: 'blur'
					// }],
					// address_email: [{
					// 	required: true,
					// 	message: '请输入邮箱',
					// 	trigger: 'blur'
					// }],

					address_country: [{
						required: true,
						message: '请选择国家',
						trigger: 'change'
					}],
					address_province: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					address_city: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					address_source_id: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					address_user_shop_id: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					address_zip_code: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					address_other_order_number: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],

				},
				alpay: "",
				wxpay: "",
				status: "",
				total: 0,
				order_bank_card: [],
				order_bank_card2: [],
				shoplist: [],
				slist: [],
				order_address: {},
				payimg: "",
				order_refund: [],
				operate: "details",
				timer1: null,
				timer2: null,
			};
		},
		created() {
			// let obj = json.COUNTRIES
			// this.countrys = Object.keys(obj).map(item => {
			// 	return {
			// 		value: item,
			// 		label: obj[item]
			// 	}
			// });
			this.id = this.$route.query.id
			this.operate = this.$route.query.operate
			this.getData();
			this.getslist()

		},
		computed: {
			getTotalPs() {
				return (data) => {
					let p = parseFloat(data.pay_price) - parseFloat(data.sign_price)
					return p.toFixed(2)
				}
			},
		},
		beforeDestroy() {
			this.clear1()
			this.clear2()
		},
		methods: {
			clear1() {
				if (this.timer1) {
					clearInterval(this.timer1)
					this.timer1 = null
				}
			},
			clear2() {
				if (this.timer2) {
					clearInterval(this.timer2)
					this.timer2 = null
				}
			},
			analysis() {
				if (!this.textarea) {
					this.$message.error('请输入要识别的内容!');
					return
				}
				this.$http.post('/api/order/address_analysis', {
					address: this.textarea,

				}).then(res => {
					if (res.code == 1) {

						this.form.address_name = res.data.name
						this.form.address_phone = res.data.phone_arr.length > 0 ? res.data.phone_arr[0] : ''
						this.form.address_address_one = res.data.result.route + res.data.result.streetNum
						// this.form.address_house_number = res.data.result.streetNum
						this.form.address_email = res.data.email
						this.form.address_country = res.data.result.country
						this.form.address_province = res.data.result.province
						this.form.address_city = res.data.result.city
						this.form.address_zip_code = res.data.result.postcode

					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}


				});
			},
			seeImg(img) {
				window.open(img, '_blank', 'noopener noreferrer');
			},

			shopChange() {
				let index = this.shoplist.findIndex(item => item.id == this.form.address_user_shop_id)
				this.form.address_user_shop_string = this.shoplist[index].name
			},
			sourceChange() {
				let index = this.slist.findIndex(item => item.id == this.form.address_source_id)
				this.form.address_source_string = this.slist[index].name
				this.$http.get('/api/user_shop/index', {
					params: {
						page: 1,
						limit: 9999,
						source_id: this.form.address_source_id
					}
				}).then(res => {
					console.log(res)
					this.shoplist = res.data.data

				});

			},

			getslist() {
				this.$http.get('/api/user_shop/source_list', {

				}).then(res => {
					console.log(res)
					this.slist = res.data

				});
			},
			paySubmit() {
				if (this.payType < 2) {
					this.payShow = false
					this.getData()
				}
				// 银联支付
				if (this.payType == 2) {
					this.$http.post('/api/order/pay_pull', {
						order_id: this.id,
						type: 4,
						extend_yl_images: this.imageUrl
					}).then(res => {
						console.log(res)
						this.payShow = false
						this.$message({
							type: 'success',
							message: '操作成功!'
						});
						setTimeout(() => {
							this.getData();
						}, 1000)
					});
				}
				// 授信支付
				if (this.payType == 3) {
					if (!this.canPay) {
						this.$message.error('额度不足，请选择其他支付方式');
						return
					}

					this.$http.post('/api/order/pay_pull', {
						order_id: this.id,
						type: 1
					}).then(res => {
						console.log(res)
						this.payShow = false
						this.$message({
							type: 'success',
							message: '操作成功!'
						});
						setTimeout(() => {
							this.getData();
						}, 2000)
					});
				}
			},
			getPayType() {
				this.$http.get('/api/order/pay_type', {

				}).then(res => {
					console.log(res)
					this.user_money = res.data.user_money

					let obj = res.data.order_bank_card

					let arr = Object.values(obj)

					arr.forEach(item => {
						this.order_bank_card.push({
							gs: item.split(' ')[0],
							yh: item.split(' ')[1],
							kh: item.split(' ')[2],
						})
					})
					this.order_bank_card2 = arr
					this.canPay = parseFloat(this.user_money) - parseFloat(this.order_money) >= 0
					setTimeout(() => {
						if (this.operate == 'address') {
							this.changeAddr()
						}
						if (this.operate == 'pay' && this.status == 10) {
							this.payShow = true
						}
					}, 1000)

				});
			},
			async copyText(data) {
				try {
					await navigator.clipboard.writeText(data);
					this.$message({
						type: 'success',
						message: '复制成功!'
					});
				} catch (err) {
					this.$message({
						message: '复制失败！你的的浏览器不支持自动复制,请手动复制!',
						type: 'warning'
					});

				}
			},
			handleAvatarSuccess(res, file) {
				console.log(file)
				this.imageUrl = file.response.data.url;
			},
			beforeAvatarUpload(file) {
				const isJPG = ['image/jpeg', 'image/png', 'image/gif', 'video/mp4'].includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 5;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 5MB!');
				}
				return isJPG && isLt2M;
			},


			changePayType(i) {
				this.payType = i
				if (i < 2) {
					let type = i == 0 ? 2 : 3
					this.$http.post('/api/order/pay_pull', {
						order_id: this.id,
						type: type
					}).then(res => {
						console.log(res)
						if (this.payType == 0) {
							this.alpay = res.data
							this.clear1()
							this.timer1 = setInterval(() => {
								this.getData(this.id)
							}, 3000)
						}
						if (this.payType == 1) {
							this.wxpay = res.data
							this.clear2()
							this.timer2 = setInterval(() => {
								this.getData(this.id)
							}, 3000)
						}

					});
				} else {
					this.clear1()
					this.clear2()
				}

			},

			goBack() {
				this.$router.go(-1);
			},
			seeReject() {
				let text = this.form.reject_message
				console.log(text)
				this.$alert(text, '驳回原因', {
					confirmButtonText: '确定',
					callback: action => {

					}
				});
			},
			// 省
			// changeProvinces(v) {
			// 	console.log(v)
			// },
			//国家
			// changeCountry(v) {
			// 	console.log(v)
			// 	let obj = json[v]
			// 	this.provinces = Object.keys(obj).map(item => {
			// 		return {
			// 			value: item,
			// 			label: obj[item]
			// 		}
			// 	});
			// 	console.log(this.provinces)
			// },
			addressOk(formName) {

				this.$refs[formName].validate((valid) => {
					if (valid) {
						delete this.form.id;
						delete this.form.status;
						this.$http.post('/api/order/order_edit_address', {
							order_id: this.id,
							...this.form
						}).then(res => {
							if (res.code == 1) {
								this.$message({
									type: 'success',
									message: '修改成功!'
								});
								this.dialogFormVisible = false
								this.getData();
							} else {
								this.$message({
									message: res.msg,
									type: 'error'
								});
							}

						});
					} else {
						this.$message.error('您有信息未填写!');

						return false;
					}
				});


			},
			pageToApply() {
				this.$router.push({
					path: "/apply",
					query: {
						id: this.id
					}
				});
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/goodsDetails",
					query: {
						id: id
					}
				});
			},
			pageToRefOrder(id) {
				this.$router.push({
					path: "/afterSalesDetails",
					query: {
						id: id
					}
				});
			},


			getData() {

				this.$http.get('/api/order/info', {
					params: {
						id: this.id
					}
				}).then(res => {
					console.log(res)
					this.data = res.data
					let form = JSON.parse(JSON.stringify(res.data.order_address))
					this.form = {
						id: form.id,
						address_name: form.name,
						address_phone: form.phone,
						address_address_one: form.address_one,
						address_address_two: form.address_two,
						address_address_three: form.address_three,
						// address_house_number: form.house_number,
						address_email: form.email,
						address_country: form.country,
						address_province: form.province,
						address_city: form.city,
						address_area: '',
						address_zip_code: form.zip_code,
						address_source_id: form.source_id,
						address_source_string: form.source_string,
						address_user_shop_id: form.user_shop_id,
						address_user_shop_string: form.user_shop_string,
						address_other_order_number: form.other_order_number,
						status: form.status,
						source_id: form.source_id,
						source_string: form.source_string,
						user_shop_id: form.user_shop_id,
						user_shop_string: form.user_shop_string,
						other_order_number: form.other_order_number,
						reject_message: form.reject_message,
					}
					this.order_address = res.data.order_address
					this.order_goods = res.data.order_goods
					// if (res.data.other_data) {
					// 	let dimg = res.data.other_data && JSON.parse(res.data.other_data)
					// 	let img = dimg && dimg.extend_yl_images
					// 	this.payimg = res.data.pay_type == 4 ? (this.http + img) : ''
					// }

					this.status = parseInt(res.data.status)
					this.total = this.order_goods.reduce((acc, curr) => acc + curr.number, 0);
					this.order_money = parseFloat(res.data.pay_price) + parseFloat(res.data.sign_price)
					this.order_refund = res.data.order_refund
					this.getPayType()


					if (res.data.status == 20) {
						this.clear1()
						this.clear2()
						this.payShow = false
					}
					this.$forceUpdate()
				});

			},

			changeAddr() {

				let index = this.slist.findIndex(item => item.id == this.form.address_source_id)
				this.form.address_source_string = this.slist[index].name
				this.$http.get('/api/user_shop/index', {
					params: {
						page: 1,
						limit: 9999,
						source_id: this.form.address_source_id
					}
				}).then(res => {
					console.log(res)
					this.shoplist = res.data.data
					this.dialogFormVisible = true
				});





			},

			recycle() {
				this.$confirm('确认已收货, 是否继续?', '订单收货', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/order/order_recycle', {
						order_id: this.id
					}).then(res => {

						if (res.code == 1) {
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
							this.getData()
						} else {
							this.$message({
								message: res.msg,
								type: 'error'
							});
						}

					});

				}).catch(() => {

				});
			},
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.payma4 {
		.t {
			height: 40px;
			line-height: 40px;

			.l {

				font-weight: 500;
				font-size: 14px;
				color: #000000;
				text-align: left;
			}

			.r {
				margin-left: 10px;
				color: #A9A9A9;
				font-size: 14px;

				span {
					font-size: 22px;
					font-weight: 600;
				}
			}
		}

		.ma {
			margin-top: 40px;
			display: flex;
			flex-direction: column;
			text-align: center;
			align-items: center;
			justify-content: center;

			img {
				width: 104px;
				height: 88px;
			}

			p {
				font-size: 12px;
				color: #FF233F;
				height: 20px;
				line-height: 20px;
				margin-top: 15px;
			}
		}
	}

	.payma4on {


		.t {
			.r {
				color: @color1;


			}
		}

		.ma {

			p {
				color: #3F3F3F;
			}
		}
	}

	.avatar {
		width: 100px;
		height: 100px;
		display: block;
	}

	.payma3 {
		.upload {
			width: 100px;
			height: 100px;
			background: #FFFFFF;
			border-radius: 2px;
			border: 1px solid #EBEBEB;
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: center;
			text-align: center;
			margin-top: 10px;

			img {
				width: 30px;
				height: 30px;
			}

			p {
				line-height: 20px;
				height: 20px;
				font-size: 14px;
				color: #A9A9A9;
				text-align: center;
				margin-top: 10px;
			}
		}

		.zh {
			margin-top: 20px;

			.l {

				font-size: 14px;
				color: #000000;
				text-align: left;
			}

			.r {
				flex: 1;
				width: 1px;
				margin-left: 20px;
				height: 40px;
				line-height: 40px;
				border: 1px solid #EBEBEB;
				position: relative;
				padding: 0 10px;
				font-size: 14px;
				color: #3F3F3F;
				// &::after {
				// 	content: '';
				// 	position: absolute;
				// 	top: 5px;
				// 	bottom: 5px;
				// 	left: 33.33%;
				// 	width: 1px;
				// 	background-color: #EBEBEB;
				// }

				// &::before {
				// 	content: '';
				// 	position: absolute;
				// 	top: 5px;
				// 	bottom: 5px;
				// 	right: 33.33%;
				// 	width: 1px;
				// 	background-color: #EBEBEB;
				// }

				.i {
					font-size: 14px;
					color: #3F3F3F;
					flex: 1;
					align-items: center;
					text-align: center;
				}
			}
		}

		.pz {
			margin-top: 20px;

			.t {
				text-align: left;
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				color: @color1;
				text-align: left;

				span {
					color: @color2;
					margin-left: 10px;
					font-size: 12px;
				}
			}

			.upload {
				img {}

				p {}
			}

		}
	}

	.payma2 {
		padding: 60px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;

		img {
			width: 200px;
			height: 200px;
		}

		p {
			margin-top: 20px;
			font-weight: 500;
			font-size: 14px;
			color: #A9A9A9;
			text-align: center;
			line-height: 24px;

			span {
				color: @color2;
				padding: 0 10px;
			}
		}
	}

	.payma1 {
		padding: 60px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;

		img {
			width: 104px;
			height: 104px;
		}

		p {
			margin-top: 20px;
			height: 20px;
			font-weight: 500;
			font-size: 14px;
			color: #A9A9A9;
			text-align: center;
			line-height: 20px;
		}
	}

	.payprice {


		font-size: 14px;
		color: #000000;
		text-align: left;

		span {
			font-weight: bold;
			font-size: 22px;
			color: #FF6A00;
			text-align: left;
			margin-left: 10px;
		}
	}

	.paytype {
		padding: 20px 0;

		.l {


			font-size: 14px;
			color: #000000;
			text-align: left;
		}

		.r {
			flex: 1;
			width: 1px;
			margin-left: 10px;

			.i {
				margin-right: 20px;
				cursor: pointer;

				.img1 {
					width: 16px;
					height: 16px;

				}

				.img2 {
					margin-left: 10px;
					width: 100px;
					height: 30px;
				}
			}
		}
	}



	.el-form-item {
		margin-bottom: 0 !important;
	}

	.tips {
		height: 30px;
		background: #FFF5EE;
		align-items: center;
		justify-content: space-between;
		line-height: 30px;
		margin: 10px auto;
		padding: 0 10px;
		border-radius: 3px;

		i {
			color: @color2;
		}

		span {
			flex: 1;
			width: 1px;
			margin-left: 10px;
			font-size: 12px;
			color: #868E99;
			text-align: left;
		}
	}

	.table-form {

		border-collapse: collapse;
		/* 关键：合并边框 */
		width: 100%;
		border: 1px solid #ccc;
		/* 可选：外边框 */
		margin-bottom: 20px;

		td {
			border: 1px solid #ccc;
			/* 细线边框 */
			padding: 10px;
		}
	}

	.textarea {
		position: relative;

		.el-button {
			position: absolute;
			bottom: 10px;
			right: 10px;
		}
	}

	.o-d-main {
		margin: 20px auto;
		background-color: #fff;
		padding: 20px;
		box-sizing: border-box;
		border-radius: 10px;
		align-items: flex-start;
		justify-content: space-between;

		.o-d-l {
			flex: 1;
			width: 1px;
			margin-right: 20px;

			.gl {

				box-sizing: border-box;
				background: #FFF5EE;
				border-radius: 6px;
				padding: 0 10px;


				.i {
					align-items: center;
					justify-content: space-between;
					height: 36px;
					line-height: 36px;
				}

				.gl-l {
					text-align: left;
					font-size: 14px;
					color: @color1;
				}

				.gl-r {
					text-align: center;
					cursor: pointer;

					span {
						font-size: 14px;
						color: @color2;
						margin-right: 5px;
					}

					i {
						color: @color2;
					}
				}
			}

			.o-hd {
				display: flex;
				align-items: center;
				height: 30px;
				line-height: 30px;
				margin-top: 10px;

				img {
					width: 16px;
					height: 16px;
				}

				p {
					flex: 1;
					width: 1px;
					margin-left: 10px;
					font-size: 14px;
					color: @color1;
					text-align: left;

					span {
						color: #3572F5;
						text-decoration-line: underline;
						margin-left: 10px;
					}
				}

			}

			.o-d-goods {
				.item {
					padding: 10px 0;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.price {
						width: 100px;

						p {
							font-size: 14px;
							color: @color1;
							text-align: left;
							line-height: 20px;
						}
					}

					.img {
						width: 50px;
						height: 50px;
						background: #FFFFFF;
						border-radius: 6px 6px 6px 6px;
						border: 1px solid #D8D8D8;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.con {
						flex: 1;
						width: 1px;
						margin-left: 10px;

						.name {

							font-weight: 500;
							font-size: 14px;
							color: @color1;
							line-height: 20px;
							text-align: left;

						}

						.p {
							font-size: 12px;
							color: #50607A;
							line-height: 20px;
							text-align: left;
						}
					}
				}

				.item1 {
					height: 40px;
					line-height: 40px;
					background-color: #F7F9FA;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.i {
						font-size: 14px;
						color: @color1;
						text-align: left;
						text-indent: 10px;
					}

					.i1 {
						flex: 1;
						width: 1px;
					}

					.i2 {
						width: 100px;
					}
				}
			}

			.o-d-title {
				font-weight: bold;
				font-size: 16px;
				color: #11192D;
				height: 30px;
				line-height: 30px;
				text-align: left;
			}

			.o-d-list {
				margin-top: 10px;
				font-size: 14px;
				margin-bottom: 10px;

				.i {
					flex: 1;
					color: #868E99;
					height: 30px;
					line-height: 30px;


					span {
						color: @color1;
					}
				}
			}

			.hr {
				margin: 20px auto;
				width: 100%;
				height: 1px;
				background-color: #eee;
			}

			.btns {
				.btn {
					width: 90px;
					height: 34px;
					line-height: 34px;
					font-size: 14px;
					border-radius: 10px 10px 10px 10px;
					text-align: center;

				}

				.btn1 {
					background-color: @color2;
					color: #fff;
				}

				.btn2 {
					background: #FFFFFF;
					border: 1px solid #D8D8D8;
					margin-left: 10px;
				}
			}

			.address {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				padding: 20px 150px 20px 0;
				position: relative;

				.bh {
					position: absolute;
					right: 10px;
					top: 45px;
					width: 100px;
					height: 24px;
					line-height: 24px;
					font-weight: 500;
					font-size: 12px;
					color: #3572F5;
					text-align: right;
					text-decoration-line: underline;
				}

				.sh {
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					right: 10px;
					top: 5px;
					padding: 0 10px;
					height: 22px;
					line-height: 22px;
					text-align: center;
					border-radius: 11px;

					img {
						width: 15px;
						height: 15px;
						margin-right: 5px;
					}

					span {
						font-size: 12px;

					}
				}

				.sh1 {
					background: #FFE5E5;

					span {
						color: #FF1717;
					}
				}

				.sh2 {
					background: #EEFFF1;

					span {
						color: #34C759;
					}
				}

				.l {
					i {
						font-size: 24px;
						color: @color2;
					}
				}

				.r {
					flex: 1;
					width: 1px;
					margin-left: 10px;
					text-align: left;

					p {
						font-size: 14px;
						color: @color1;
						line-height: 24px;

						span {
							margin-right: 20px;
						}
					}
				}
			}

			.state {

				height: 40px;
				line-height: 40px;
				font-weight: 800;
				font-size: 28px;
				color: #FF6A00;
				text-align: left;
				margin-top: 20px;
			}

			.back {
				height: 30px;
				line-height: 30px;
				text-align: left;

				span {
					font-size: 16px;
					color: #11192D;
					margin-left: 5px;
				}

				&:hover {
					i {
						color: @color2;
					}

					span {
						color: @color2;
					}
				}
			}
		}

		.o-d-r {
			width: 370px;

			background: #FFFFFF;
			border-radius: 10px;
			border: 1px solid #EBEBEB;
			padding: 20px;
			box-sizing: border-box;

			.title {

				height: 30px;
				line-height: 30px;
				font-weight: bold;
				font-size: 18px;
				color: @color1;
				text-align: left;
			}

			.hr {
				margin: 10px auto;
				width: 100%;
				height: 1px;
				background-color: #eee;
			}

			.list {
				margin-top: 10px;

				.item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					height: 34px;
					line-height: 34px;

					.l {
						text-align: left;
						font-size: 14px;
						color: #868E99;
					}

					.r {
						flex: 1;
						width: 1px;
						text-align: right;
						font-size: 14px;
						color: @color1;
						align-items: center;
						;
						justify-content: flex-end;

						span {
							font-size: 16px;
							font-weight: 600;
						}

						img {
							width: 15px;
							height: 15px;
							margin-left: 10px;
						}
					}
				}
			}
		}
	}
</style>